<div class="row justify-content-center login-container">

    <div class="col-lg-12 login-form-right">

        <div class="container">
            <h1 class="title text-center welcome-users">{{language.proctoringSystemCheck}}</h1>
            <div class="alert center" style="padding: 0.75em 0; text-align: center;" aria-live="polite">
                <p class="font-weight-bold" *ngIf="isLoading" style="color:white; background-color: cornflowerblue;">
                    <!-- <span><img style="height:40px;" src="/assets/img/spinner.gif"
                            [alt]="language.loadingCheck" /></span> -->
                    <span><app-loading-spinner [width]="40" [height]="40"></app-loading-spinner></span>
                </p>
            </div>

            <section aria-label="System check status">
                <ul>
                    <li>
                        <i *ngIf="cameraAvailable" class="fa fa-check-square-o  text-green" aria-hidden="true"></i>
                        <i *ngIf="!cameraAvailable" class="fa fa-square-o text-danger" aria-hidden="true"></i>

                        {{language.camera}}: <strong>{{ (cameraAvailable && cameraResponse=='Yes') ? language.available
                            :
                            language.notAvailable
                            }}</strong>
                        <i *ngIf="cameraAvailable && cameraResponse=='Yes'" class="fas fa-video ml-3 text-green"
                            aria-hidden="true"></i>
                        <i *ngIf="!cameraAvailable|| !cameraResponse || cameraResponse=='No'"
                            class="fas fa-video-slash ml-3 text-danger" aria-hidden="true"></i>
                    </li>

                    <li> <i *ngIf="speakerAvailable" class="fa fa-check-square-o  text-green" aria-hidden="true"></i>
                        <i *ngIf="!speakerAvailable" class="fa fa-square-o text-danger" aria-hidden="true"></i>
                        {{language.speaker}}: <strong>{{ (speakerAvailable && speakerResponse=='Yes') ?
                            language.available :
                            language.notAvailable
                            }}</strong>
                        <i *ngIf="speakerAvailable && speakerResponse=='Yes'" class="fas fa-volume-up ml-3 text-green"
                            aria-hidden="true"></i>
                        <i *ngIf="!speakerAvailable || !speakerResponse || speakerResponse=='No'"
                            class="fas fa-volume-mute ml-3 text-danger" aria-hidden="true"></i>
                    </li>
                    <li> <i *ngIf="microphoneAvailable" class="fa fa-check-square-o  text-green" aria-hidden="true"></i>
                        <i *ngIf="!microphoneAvailable" class="fa fa-square-o text-danger" aria-hidden="true"></i>
                        {{language.microphone}}: <strong>{{
                            microphoneAvailable
                            ? language.available : language.notAvailable }}</strong>
                        <i *ngIf="microphoneAvailable" class="fas fa-microphone-alt ml-3 text-green"
                            aria-hidden="true"></i>
                        <i *ngIf="!microphoneAvailable" class="fas fa-microphone-alt-slash ml-3 text-danger"
                            aria-hidden="true"></i>
                    </li>
                    <li> <i *ngIf="canRecord" class="fa fa-check-square-o  text-green" aria-hidden="true"></i>
                        <i *ngIf="!canRecord" class="fa fa-square-o text-danger" aria-hidden="true"></i>
                        {{language.recording}}: <strong>{{
                            canRecord
                            ? language.available : language.notAvailable }}</strong>
                        <i *ngIf="canRecord" class="fas 	fas fa-play-circle ml-3 text-green" aria-hidden="true"></i>
                        <i *ngIf="!canRecord" class="fas 	fas fa-stop-circle ml-3 text-danger" aria-hidden="true"></i>
                    </li>
                    <li> <i *ngIf="osVersion&& osVersion!=language.unknown" class="fa fa-check-square-o  text-green"
                            aria-hidden="true"></i>
                        <i *ngIf="!osVersion || osVersion==language.unknown" class="fa fa-square-o text-danger"
                            aria-hidden="true"></i>
                        {{language.osVersion}}: <strong>{{
                            osVersion
                            }}</strong>
                    </li>
                    <li> <i *ngIf="browserVersion&& browserVersion!=language.unknown"
                            class="fa fa-check-square-o  text-green" aria-hidden="true"></i>
                        <i *ngIf="!browserVersion || browserVersion==language.unknown"
                            class="fa fa-square-o text-danger" aria-hidden="true"></i> {{language.browserVersion}}:
                        <strong>{{ browserVersion
                            }}</strong>
                    </li>
                    <li> <i *ngIf="isDesktopDevice" class="fas fa fa-check-square-o  text-green" aria-hidden="true"></i>
                        <i *ngIf="!isDesktopDevice" class="fa fa-square-o text-danger" aria-hidden="true"></i>
                        {{language.deviceType}}:
                        <strong>{{deviceType}}</strong>
                    </li>
                    <h3>{{language.networkCheck}} {{dateOfCheck}}</h3>
                    <li>
                        <i *ngIf="!isLoadingNetworkCheck" class="fas fa fa-check-square-o  text-green"
                            aria-hidden="true"></i>
                        <i *ngIf="isLoadingNetworkCheck" class="fa fa-square-o text-danger" aria-hidden="true"></i>
                        {{language.latency}}: <strong>{{ isLoadingNetworkCheck? (showContinue?
                            language.loadingWait:language.unknown):latencyMs }}</strong>
                    </li>
                    <li>
                        <i *ngIf="!isLoadingNetworkCheck" class="fas fa fa-check-square-o  text-green"
                            aria-hidden="true"></i>
                        <i *ngIf="isLoadingNetworkCheck" class="fa fa-square-o text-danger" aria-hidden="true"></i>
                        {{language.speed}}: <strong>{{ isLoadingNetworkCheck? (showContinue?
                            language.loadingWait:language.unknown)
                            :speedMbps }}</strong>
                    </li>
                    <li>
                        <i *ngIf="showContinue && totalScore ==2" class="fas fa fa-check-square-o  text-green"
                            aria-hidden="true"></i>
                        <i *ngIf="showContinue && totalScore == 1"
                            class="fa fa-warning text-yellow" aria-hidden="true"></i>
                        <i *ngIf="showContinue && totalScore == 0" class=" fa fa-times  text-danger"
                            aria-hidden="true"></i>
                        <i *ngIf="isLoadingNetworkCheck" class="fa fa-square-o text-danger" aria-hidden="true"></i>

                        Result: <strong>{{ isLoadingNetworkCheck? (showContinue?
                            language.loadingWait:language.unknown)
                            :networkResult }}</strong>

                    </li>

                </ul>
            </section>
            <div class="mb-3">
                <button class="btn btn-primary" (click)="runCheck(true)">{{language.runCheck}}</button>
                <button class="btn btn-primary" (click)="continueClicled()"
                    *ngIf="showContinue">{{language.backToLogin}}</button>
            </div>

            <!-- Modal -->
            <div class="modal fade" id="systemcheckModal" data-backdrop="static" aria-labelledby="systemcheckModalLabel"
                aria-modal="true" role="dialog">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="systemcheckModalLabel">{{language.mediaChecks}}</h5>
                            <!-- <button type="button" class="close h3" data-dismiss="modal"
                                aria-label="Close" (click)="closeCheck()">&times;</button> -->
                        </div>
                        <div class="modal-body">
                            <section aria-labelledby="camera-check">
                                <h3 id="camera-check">{{language.cameraCheck}}:</h3>
                                <div class="camera-container">
                                    <video #videoElement autoplay playsinline [attr.aria-label]="language.cameraPreview"></video>
                                    <canvas #canvasElement style="display: none;"></canvas>
                                    <button *ngIf="cameraAvailable" class="btn btn-info btn-sm mb-2"
                                        (click)="captureAndAnalyzeImage()" [disabled]="isAnalyzing">
                                        <span *ngIf="isAnalyzing" class="spinner-border spinner-border-sm me-2"
                                            role="status" aria-hidden="true"></span>
                                        {{this.analyzeButtonText ? this.analyzeButtonText : 'Check Quality'}}
                                    </button>
                                    <div *ngIf="imageQualityStatus">
                                        <p>Result: {{imageQualityStatus}}</p>
                                        <ul class="text-start small text-danger">
                                            <li *ngFor="let comment of imageQualityIssues">{{comment}}</li>
                                        </ul>
                                    </div>
                                    <select class="form-control form-select" [(ngModel)]="cameraResponse"
                                        *ngIf="!camError">
                                        <option value=undefined selected disabled>{{language.canSeeSelf}}</option>
                                        <option value="Yes">{{language.yes}}</option>
                                        <option value="No">{{language.no}}</option>
                                    </select>
                                    <p class="text-danger" role="alert">{{camError}}</p>

                                    <!-- <button (click)="captureImage()">Capture Image</button> -->
                                    <!--                               
                                                                                    <div *ngIf="capturedImage">
                                                                                      <h3>Captured Image:</h3>
                                                                                      <img [src]="capturedImage" alt="Captured Image" />
                                                                                    </div> -->

                                </div>
                            </section>
                            <section aria-labelledby="microphone-check">
                                <h3 id="microphone-check">{{language.microphoneCheck}}:</h3>
                                <p class="text-danger">{{micError}}</p>
                                <div *ngIf="isMicrophoneActive" class="mb-3">
                                    <div class="volume-bar">
                                        <div [style.width.%]="microphoneVolume" class="volume-indicator"></div>
                                    </div>
                                </div>
                            </section>

                            <section aria-labelledby="speaker-check">
                                <h3 id="speaker-check">{{language.speakerCheck}}</h3>
                                <button (click)="checkSpeakers()"
                                    class="btn btn-secondary">{{language.playTestSound}}</button>
                                <div *ngIf="isPlaying">
                                    <p>{{language.playingTestSound}}...</p>
                                </div>
                                <select class="form-control form-select mt-2" [(ngModel)]="speakerResponse"
                                    *ngIf="checkSpeakerCliked">
                                    <option value=undefined selected disabled>{{language.canHearBeepSound}}</option>
                                    <option value="Yes">{{language.yes}}</option>
                                    <option value="No">{{language.no}}</option>
                                </select>
                            </section>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeCheck()"
                                [disabled]="!speakerResponse || !cameraResponse">{{language.continue}}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="warnings.length > 0" class="alert alert-warning" role="alert" aria-live="assertive">
                <ul>
                    <li *ngFor="let warning of warnings">{{ warning }}</li>
                </ul>
            </div>
        </div>
    </div>
</div>